import { render, staticRenderFns } from "./ViewTeam.vue?vue&type=template&id=87a6290c&scoped=true&"
import script from "./ViewTeam.vue?vue&type=script&lang=js&"
export * from "./ViewTeam.vue?vue&type=script&lang=js&"
import style0 from "./ViewTeam.vue?vue&type=style&index=0&id=87a6290c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a6290c",
  null
  
)

export default component.exports